import React from 'react';
const tomes = [{
  emoji: '💀',
  title: 'Tomo 1 — El Despertar (La Verdad que Nadie te Dijo)',
  desc: 'Por qué fallaste mil veces. La biología detrás del scroll infinito y cómo romper el ciclo desde hoy.'
}, {
  emoji: '🧬',
  title: 'Tomo 2 — Bio-Hack Dopamínico',
  desc: 'Protocolo de reset de dopamina en 7 días. Recuperá el placer de trabajar en lo difícil sin forzar.'
}, {
  emoji: '🏗️',
  title: 'Tomo 3 — Ingeniería de Entorno',
  desc: 'Rediseñá tu espacio físico y digital para que distraerte sea difícil y enfocarte sea automático.'
}, {
  emoji: '⏰',
  title: 'Tomo 4 — Sistema de 3 Bloques',
  desc: 'El método para lograr en 90 minutos lo que antes te llevaba una semana de interrupciones.'
}, {
  emoji: '🚨',
  title: 'Tomo 5 — Protocolo S.O.S. Anti-Recaída',
  desc: 'Qué hacer cuando la motivación se va. El sistema de rescate para los días que todo falla.'
}, {
  emoji: '🏆',
  title: 'Tomo 6 — Identidad Ejecutora',
  desc: 'El paso final. Dejá de ser el que "está por empezar" y convertite en el que siempre TERMINA.'
}];
const includes = ['Protocolo de reset dopamínico paso a paso', 'Checklist diario, semanal y mensual de ejecución', 'Scripts de arranque para entrar en foco en 3 minutos', 'Sistema de bloqueo digital para iPhone y Android', 'Protocolo nocturno de apagado mental (7 minutos)', 'Tablero de control de progreso a 90 días', 'Plan anti-recaída para cuando todo falla', '100% adaptado a la realidad del emprendedor argentino'];
export function WhatYouGet() {
  return <section className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: '#0d0d0d',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-307">
      <div className="mx-auto max-w-4xl" data-id="element-308">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center leading-10 text-white m-0 mb-8" data-id="element-309">
          Lo que{' '}
          <span className="text-yellow-400" data-id="element-310">recibís</span>
        </h2>

        {/* 6 Tomos Card */}
        <div className="mx-auto max-w-3xl mb-8" data-id="element-311">
          <div className="bg-white/5 border border-yellow-400/30 rounded-xl p-5 shadow-sm" data-id="element-312">
            <h3 className="text-lg font-black text-yellow-400 m-0 mb-1" data-id="element-313">
              🧠 LOS 6 TOMOS
            </h3>
            <p className="text-xs text-gray-400 m-0 mb-4" data-id="element-314">
              Para emprendedores, freelancers y creadores que quieren recuperar
              el control de su atención
            </p>

            <div className="space-y-3" data-id="element-315">
              {tomes.map(tome => <div key={tome.title} className="flex items-center gap-2 text-white" data-id="element-316">
                  <span className="text-lg" data-id="element-317">{tome.emoji}</span>
                  <div className="flex-1 text-sm" data-id="element-318">
                    <span className="font-bold text-white" data-id="element-319">{tome.title}</span>{' '}
                    <span className="text-gray-400" data-id="element-320">{tome.desc}</span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        {/* Each Tome Includes */}
        <div className="mx-auto max-w-3xl bg-yellow-400/5 text-center border border-yellow-400/30 rounded-xl p-6 shadow-sm" data-id="element-321">
          <h3 className="text-lg font-black text-yellow-400 m-0 mb-4" data-id="element-322">
            Cada tomo incluye:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-323">
            {includes.map(item => <div key={item} className="flex items-start gap-2 text-left" data-id="element-324">
                <span className="shrink-0 font-bold text-yellow-400 text-sm" data-id="element-325">
                  ✅
                </span>
                <span className="text-xs text-gray-300" data-id="element-326">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}